import React, { useEffect, useState } from "react";
import api from "./api/axios";
import { getImageUrl } from "./utils/image";
import { useSearch } from "./contexts/SearchContext";

export default function AdminTopBar() {
  const [adminName, setAdminName] = useState("");
  const [avatarUrl, setAvatarUrl] = useState("/avatar.png");
  const { searchQuery, setSearchQuery } = useSearch();

  useEffect(() => {
    async function fetchProfile() {
      try {
        const res = await api.get("/profile");
        setAdminName(res.data.nama_ktp || "Admin");
        setAvatarUrl(
          res.data.image_url
            ? getImageUrl(res.data.image_url)
            : "/avatar.png",
        );
      } catch (err) {
        console.error("Failed to load profile", err);
      }
    }
    fetchProfile();
  }, []);

  return (
    <div className="flex justify-between items-center mb-4">
      <input
        type="text"
        placeholder="Masukkan kata kunci"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="w-1/2 border rounded px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-700">{adminName}</span>
        <img src={avatarUrl} alt="Admin" className="h-8 w-8 rounded-full" />
      </div>
    </div>
  );
}